import styled from 'styled-components';
import { ContentBanner } from '../../components/ContentBanner';

export const Wrapper = styled(ContentBanner)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
